export const BUTTON_TYPES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  OUTLINE: 'outline',
  TEXT: 'text',
  ERROR: 'error',
  SUCCESS: 'success',
  OUTLINE_BLUE: 'outlineBlue',
};

export const BUTTON_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  BIG: 'big',
};

export const BUTTON_SPINNER_SIZES = {
  [BUTTON_SIZES.SMALL]: BUTTON_SIZES.SMALL,
  [BUTTON_SIZES.MEDIUM]: BUTTON_SIZES.MEDIUM,
  [BUTTON_SIZES.BIG]: BUTTON_SIZES.BIG,
};

export const BUTTON_SPINNER_TYPES = {
  [BUTTON_TYPES.PRIMARY]: BUTTON_TYPES.PRIMARY,
  [BUTTON_TYPES.SECONDARY]: BUTTON_TYPES.SECONDARY,
  [BUTTON_TYPES.OUTLINE]: BUTTON_TYPES.OUTLINE,
  [BUTTON_TYPES.TEXT]: BUTTON_TYPES.TEXT,
  [BUTTON_TYPES.ERROR]: BUTTON_TYPES.ERROR,
  [BUTTON_TYPES.SUCCESS]: BUTTON_TYPES.SUCCESS,
};
